import { ISelect } from '@common/types/element';
import React, { FC, Fragment, useEffect } from 'react';
import DropDown from './CustomPicker';
import useDropdown, { FIND_ALL, useDropdownProps } from './hook';
import { get } from 'lodash';

const CustomPicker: FC<ISelect> = (attrs) => {
  const {
    showDropDown,
    value,
    list,
    handleShowDropdown,
    handleHiddenDropdown,
    handleChangeValue,
    onLoadMore,
    isLoadMore,
  }: useDropdownProps = useDropdown(attrs);

  // find all when empty
  useEffect(() => {
    const currentValueInput = get(attrs, 'valueInput');
    const findAllWhenEmpty = get(attrs, 'findAllWhenEmpty.enabled', false);

    if (findAllWhenEmpty && !currentValueInput) {
      handleChangeValue(FIND_ALL);
    }
  }, [attrs.valueInput]);

  // reset to empty when list data is changed
  useEffect(() => {
    if (value && value !== FIND_ALL) {
      const isValueExist = list?.find((item: any) => item?.value === value);
      if (!isValueExist) {
        handleChangeValue(null);
      }
    }
  }, [value, list]);

  if (list.length < 0) return <Fragment />;

  return (
    <DropDown
      mode={'outlined'}
      placeholder={attrs.placeholder}
      value={value}
      setValue={handleChangeValue}
      list={list as any}
      visible={showDropDown}
      showDropDown={handleShowDropdown}
      onDismiss={handleHiddenDropdown}
      onLoadMoreForm={onLoadMore}
      isLoadMoreForm={isLoadMore}
      attributes={attrs}
      numberOfLines={attrs.numberOfLines}
      isError={!!attrs.inputError}
    />
  );
};

export default CustomPicker;
